export default "__VITE_ASSET__e8ec1745__"